import { Component, ElementRef, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { TemplateService } from 'src/app/core/services/template.service';
import { ToastService } from 'src/app/core/services/toast.service';
import { ConfirmModalService } from 'src/app/core/services/confirm-modal.service';

@Component({
    selector: 'app-templates',
    templateUrl: './templates.component.html',
    styleUrl: './templates.component.scss',
    standalone: false
})
export class TemplatesComponent {
  loading = false;
  successMessage = '';
  templates: any[] = [];
  isAddDocument: boolean = false;


  constructor(
    private templateService: TemplateService,
    private toastService: ToastService,
    private router: Router,
    private confirmModalService: ConfirmModalService
  ) { }

  ngOnInit() {
    this.getTemplates();
  }

  getTemplates() {
    this.loading = true;
    this.templateService.getAllTemplates().subscribe((res: any) => {
      this.templates = res;
      this.loading = false;
    },
      () => {
        this.loading = false;
      });
  }

  addTemplate = () => {
    this.isAddDocument = true;
  }

  useTemplate(template: any) {
    this.router.navigate(
      ['/customer/esign/send-document'],
      {
        queryParams: {
          templateId: template._id
        }
      }
    );
  }

  back(event:any) {
    this.isAddDocument = false;
    this.selectedTemplate = {};
    if (event?.addTemp) this.getTemplates();
  }

  isViewMode = false;
  selectedTemplate: any = {};
  documentData: any = {};

  templateAction(template: any, action: string) {
    switch (action) {
      case 'view':
        this.isViewMode = true;
        if (template.fileUrl) {
          this.documentData = {
            title: template.name,
            description: template.description,
            pdfUrl: template.fileUrl,
            allSignersPositions: template.allSignersPositions
          }

        }
        break;

      case 'download':
        if (!template?.fileUrl) {
          this.toastService.showToaster('Error', 'No file available to download.', 'error');
          return;
        }

        const link = document.createElement('a');
        link.href = template.fileUrl;
        link.target = '_blank';
        link.download = template.name ? `${template.name}.pdf` : 'template.pdf';
        link.click();
        break;

 case 'edit':
  this.isAddDocument = true;
  this.selectedTemplate = template;
  break;

case 'delete':
  this.confirmModalService.open(
    'Delete Template',
    'Are you sure you want to delete this template?',
    () => {
      this.deleteTemplate(template);
    },
    'Delete',
    'Cancel'
  );
  break;
    }

  }
  deleteTemplate(template: any) {
  this.loading = true;

  this.templateService.deleteTemplate(template?._id).subscribe(
    (res: any) => {
      this.loading = false;
      this.getTemplates();

      this.toastService.showToaster(
        "Deleted Template",
        res?.message || "Template successfully deleted.",
        "success"
      );
    },
    (err) => {
      this.loading = false;
    }
  );
}

  backView() {
    this.isViewMode = false;
  }

  copyTemplateId(id: string) {
    navigator.clipboard.writeText(id);
    this.toastService.showToaster("Copied", "Template ID copied", "success");
  }
}
